import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'Főoldal', href: '/' },
  { name: 'Képzések', href: '/#kepzesek' },
  { name: 'Ingatlanközvetítői képzés', href: '/ingatlan' },
  { name: 'Céges tréningek', href: '/b2b' },
  { name: 'Oktatóink', href: '/#oktatok' },
  { name: 'Rólunk', href: '/rolunk' },
  { name: 'Kapcsolat', href: '/#kapcsolat' },
  { name: 'Tananyagok', href: '/tananyagok' },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const handleNavClick = (href) => {
    setIsOpen(false);
    if (!href.includes('#')) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-blur border-b border-white/10' : 'bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-14">
          <Link
            to="/"
            className="flex items-center"
            data-testid="nav-logo"
          >
            <img
              src="/az-akademia-logo.png"
              alt="AZ AKADÉMIA"
              className="h-12 md:h-16 w-auto bg-white rounded-lg px-3 py-2"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-white/80 hover:text-brand-light-green text-sm tracking-wide whitespace-nowrap transition-colors duration-300"
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/jelentkezes"
              className="btn-primary text-sm whitespace-nowrap"
              data-testid="nav-cta-booking"
            >
              Jelentkezek
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="xl:hidden text-white p-2"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="xl:hidden nav-blur border-t border-white/10"
            data-testid="mobile-menu"
          >
            <div className="container-custom py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="text-white/80 hover:text-brand-light-green text-base py-2 transition-colors"
                  data-testid={`mobile-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/jelentkezes"
                onClick={() => handleNavClick('/jelentkezes')}
                className="btn-primary text-center mt-4"
                data-testid="mobile-cta-booking"
              >
                Jelentkezek
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
